import { EventEmitter } from "events";

const dataEvents = new EventEmitter();
const selectionEvents = new EventEmitter();

export { dataEvents, selectionEvents };
